import { Component, Inject } from '@angular/core';
import {MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA} from '@angular/material/bottom-sheet';

@Component({
    selector: 'bottom-sheet',
    template: `
        <mat-nav-list>
        <div class="search" *ngIf="show=='true'">
        <input type="text" placeholder="Search" [(ngModel)]="search">
        <ion-icon name="search"></ion-icon>
        </div>
        <a *ngFor="let item of items | search:'name,firstName,region,identificationNo':search" mat-list-item (click)="closeBottom(item)">
          <a *ngIf="item.name">{{item.name}}</a>
          <a *ngIf="item.firstName">{{item.firstName}}</a>
          <a *ngIf="item.region">{{item.region}}</a>
          <a *ngIf="item.identificationNo">{{item.identificationNo}}</a>       
        </a>
        </mat-nav-list>
    `,
  })
  export class BottomSheet {


    items = this.data;
    search;
    show;
    constructor(private ref: MatBottomSheetRef<BottomSheet>,
                @Inject(MAT_BOTTOM_SHEET_DATA) public data: any) {
                  this.show=localStorage.getItem('showBar');
                }
  
    closeBottom(item) {
      this.ref.dismiss(item);
      event.preventDefault();
    }
  }